<ng-content select="[dropdown-icon-left]"></ng-content>

<span class="dropdown-item-label">
  <ng-content></ng-content>
</span>

<ng-content select="[dropdown-icon-right]"></ng-content>
